const base = "/uxx"

export default [
    {
        path: base,
        name: "uxxhome",
        meta: {
            noAuthRequired: true
        },
        component: () => import("./UXXHome.vue")
    },
    {
        path: base + "/auth",
        name: "auth",
        meta: {
            noAuthRequired: true
        },
        component: () => import("./Authorization.vue")
    },
    {
        path: base + "/notifications",
        name: "notifications",
        component: () => import("./Notifications.vue")
    },
]
